<template>
  <div>
    <el-form ref="dataForm" :model="dataForm" label-width="0" :inline-message="true" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
      <!-- 董事|股东(个人)的护照身份证件 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="individualMembers.length != 0">
          <p class="messageTitle">
            {{ $t("enroll.upload.identityTitle") }}
            <el-popover placement="bottom" trigger="hover">
              <div>
                <p class="lh10 fs12 preLine">
                  {{ $t("enroll.upload.certificationRequirements") }}
                </p>
              </div>
              <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
            </el-popover>
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.transferIdentityTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="individualMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row)}.identificationUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row)}.identificationUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.identificationUrls"
                      :action="`${ossUploadUrl}/fileUpload/identificationUrls/upload`"
                      :button-text="$t('enroll.upload.identityUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>

                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row)}.holdingIdentificationUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row)}.holdingIdentificationUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.holdingIdentificationUrls"
                      :action="`${ossUploadUrl}/fileUpload/holdingIdentificationUrls/upload`"
                      :button-text="$t('enroll.upload.identityHoldUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 董事|股东的近三个月以内的地址证明原件扫描件 (例如: 含姓名、地址的水电单据) -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="allActiveMembers.length != 0">
          <p class="messageTitle">{{ $t("enroll.upload.siteTitle") }}</p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.transferSiteTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="allActiveMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.duty')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row)}.addressIdUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row)}.addressIdUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.addressIdUrls"
                      :action="`${ossUploadUrl}/fileUpload/addressIdUrls/upload`"
                      :button-text="$t('enroll.upload.siteUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 股东(公司)的营业执照原件扫描件, 只针对公司股东（法人） -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="corporateMembers.length != 0">
          <p class="messageTitle">{{ $t("enroll.upload.businessTitle") }}</p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.transferIdentityTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="corporateMembers">
              <el-table-column prop="fullName" :label="$t('enroll.upload.nameOrCompany')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.upload.shareholderOrCompany')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`companyMemberList.${getRealIndex(scope.row)}.businessLicenseUrls`"
                    :ref="`companyMemberList.${getRealIndex(scope.row)}.businessLicenseUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.businessLicenseUrls"
                      :action="`${ossUploadUrl}/fileUpload/businessLicenseUrls/upload`"
                      :button-text="$t('enroll.upload.businessUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 拟转移公司的Business Profile (营业执照) & 章程 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.transferProfileAndArticles") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.transferProfileAndArticlesSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferBusinessProfileAndArticleUrls"
                  :ref="'transferBusinessProfileAndArticleUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferBusinessProfileAndArticleUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferBusinessProfileAndArticleUrls/upload`"
                    :button-text="$t('enroll.upload.transferProfileUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 拟转移公司的经营活动 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.upload.transferActivities") }}
        </p>
        <p class="fs13 pt2">
          {{ $t("enroll.upload.transferActivitiesSmall") }}
        </p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferBusinessActivityDocUrls"
                  :ref="'transferBusinessActivityDocUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferBusinessActivityDocUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferBusinessActivityDocUrls/upload`"
                    :button-text="$t('enroll.upload.transferDescribeUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 拟转移公司的股权架构图 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">{{ $t("enroll.upload.transferStructure") }}</p>
        <p class="fs13 pt2">{{ $t("enroll.upload.transferStructureSmall") }}</p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferShareholdingStructureUrls"
                  :ref="'transferShareholdingStructureUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferShareholdingStructureUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferShareholdingStructureUrls/upload`"
                    :button-text="$t('enroll.upload.transferStructureUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 拟转移公司的最新的年度财务报告(若适用) -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">{{ $t("enroll.upload.transferFinancial") }}</p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferAnnualFinancialReportUrls"
                  :ref="'transferAnnualFinancialReportUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferAnnualFinancialReportUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferAnnualFinancialReportUrls/upload`"
                    :button-text="$t('enroll.upload.transferFinancialUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 拟转移公司的注册地址证明原件扫描件 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">{{ $t("enroll.upload.transferAddress") }}</p>
        <p class="fs13 pt2">{{ $t("enroll.upload.transferAddressSmall") }}</p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferRegisteredOfficeAddressCertificateUrls"
                  :ref="'transferRegisteredOfficeAddressCertificateUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferRegisteredOfficeAddressCertificateUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferRegisteredOfficeAddressCertificateUrls/upload`"
                    :button-text="$t('enroll.upload.transferAddressUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 拟转移公司的现任公司秘书的信息 -->
      <div class="pt10 mb120 messageWrap">
        <p class="messageTitle">{{ $t("enroll.upload.transferSecretary") }}</p>
        <p class="fs13 pt2">{{ $t("enroll.upload.transferSecretarySmall") }}</p>
        <div class="pt20">
          <el-table border :data="[dataForm]">
            <el-table-column :label="$t('enroll.upload.already')" align="center">
              <template slot-scope="scope">
                <el-form-item
                  prop="transferSecretaryParticularsUrls"
                  :ref="'transferSecretaryParticularsUrls'"
                  :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                >
                  <table-upload
                    v-model="scope.row.transferSecretaryParticularsUrls"
                    :action="`${ossUploadUrl}/fileUpload/transferSecretaryParticularsUrls/upload`"
                    :button-text="$t('enroll.upload.transferSecretaryUpload')"
                    :isReadonly="isReadonly"
                  />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 最终受益人的身份证件/营业执照和地址证明 -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.questionnaire?.ultimateBeneficiaryInfo?.length">
          <p class="messageTitle">
            {{ $t("enroll.upload.ultimateBeneficialId") }}
          </p>
          <p class="fs13 pt2">
            {{ $t("enroll.upload.ultimateBeneficialIdTitleSmall") }}
          </p>
          <div class="pt20">
            <el-table border :data="dataForm.questionnaire.ultimateBeneficiaryInfo">
              <el-table-column prop="fullName" :label="$t('enroll.upload.name')" align="center" width="300px"></el-table-column>
              <el-table-column :label="$t('enroll.intitle.type')" align="center" width="200px">
                <template slot-scope="scope">
                  <p>{{ getGlobalLabel("memberTypeList", scope.row.memberType) }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="`questionnaire.ultimateBeneficiaryInfo.${scope.$index}.ultimateBeneficiaryBusinessLicenseUrls`"
                    :ref="`questionnaire.ultimateBeneficiaryInfo.${scope.$index}.ultimateBeneficiaryBusinessLicenseUrls`"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.ultimateBeneficiaryBusinessLicenseUrls"
                      :action="`${ossUploadUrl}/fileUpload/ultimateBeneficiaryBusinessLicenseUrls/upload`"
                      :button-text="$t('enroll.upload.ultimateBeneficialIdUpload')"
                      :accept="'image/jpg,image/jpeg,image/png,application/pdf,application/msword,text/plain'"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 本次公司设立申请的授权文件扫描件(若申请人不是新设公司的董事或直接/间接股东) -->
      <div>
        <div class="pt10 mb120 messageWrap" v-if="dataForm.applicantPosition == 'INDIRECT_SHAREHOLDER' || dataForm.applicantPosition == 'OTHER'">
          <p class="messageTitle">
            {{ $t("enroll.upload.notApplicantTitle") }}
          </p>
          <div class="pt20">
            <el-table border :data="[dataForm]">
              <el-table-column :label="$t('enroll.upload.already')" align="center">
                <template slot-scope="scope">
                  <div v-if="dataForm.applicantPosition == 'OTHER'">
                    <el-form-item
                      prop="authorizationUrls"
                      ref="authorizationUrls"
                      :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                    >
                      <table-upload
                        v-model="scope.row.authorizationUrls"
                        :action="`${ossUploadUrl}/fileUpload/authorizationUrls/upload`"
                        :button-text="$t('enroll.upload.authorizationFileUpload')"
                        :isReadonly="isReadonly"
                      />
                    </el-form-item>
                  </div>
                  <!-- 申请人的身份证件原件扫描件 -->
                  <el-form-item
                    prop="applicantIdentificationUrls"
                    ref="applicantIdentificationUrls"
                    :rules="{ type: 'array', required: true, message: $t('common.placeholder.upload'), trigger: 'submit' }"
                  >
                    <table-upload
                      v-model="scope.row.applicantIdentificationUrls"
                      :action="`${ossUploadUrl}/fileUpload/applicantIdentificationUrls/upload`"
                      :button-text="$t('enroll.upload.applicantIdentityUpload')"
                      :isReadonly="isReadonly"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import { validateLocation } from "@/utils/common";
import { mapGetters } from "vuex";
export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ossUploadUrl: request.defaults.baseURL,
      dataForm: {},
    };
  },
  computed: {
    ...mapGetters("constant", ["getGlobalLabel"]),
    individualMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.memberType === "INDIVIDUAL" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    corporateMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.memberType === "CORPORATE" && m.positionHeld !== "NOMINEE_DIRECTOR");
    },
    allActiveMembers() {
      return (this.dataForm.companyMemberList || []).filter(m => m.positionHeld !== "NOMINEE_DIRECTOR");
    },
  },
  methods: {
    getRealIndex(row) {
      return this.dataForm.companyMemberList.indexOf(row);
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      const params = JSON.parse(JSON.stringify(this.dataForm));

      if (params.applicantPosition !== "OTHER") {
        params.authorizationUrls = [];
      }
      if (params.applicantPosition !== "INDIRECT_SHAREHOLDER" && params.applicantPosition !== "OTHER") {
        params.applicantIdentificationUrls = [];
      }

      return params;
    },

    // 触发必填校验(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
    // 提交
    submitInfo() {
      this.$refs["dataForm"].validate((valid, object) => {
        if (valid) {
          this.saveHttp("submit");
        } else {
          validateLocation(object, this);
          return false;
        }
      });
    },
    // 页面初始化数据整理
    pageInit(data) {
      this.dataForm = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
}
</style>
